import { ChangeEvent, useEffect, useRef, useState } from "react";
import { FormHandles } from "@unform/core";
import { v4 as uuid } from 'uuid';
import { Flex, Icon, Image, Radio, RadioGroup, Stack, Tab, TabList, TabPanels, Tabs, Text, useToast } from "@chakra-ui/react";
import { MdFace, MdOutlineAddIcCall } from 'react-icons/md';
import { RiMap2Line, RiMenLine, RiStore2Line, RiWomenLine } from 'react-icons/ri';
import { FiCamera, FiX, FiImage } from 'react-icons/fi';
import * as Yup from 'yup';
import Resizer from 'react-image-file-resizer';

import api from "../../../services/api";
import Alert from "../../Alert";
import Input from "../../Inputs/Input";
import InputDate from "../../Inputs/InputDate";
import SelectInput from "../../Inputs/Selects/SelectInputAntigo";
import { useAuth } from "../../../hooks/auth";
import getValidationErrors from "../../../utils/getValidationErrors";
import LoadingTabCliente from "../LoadingTabCliente";
import AddPhoneClienteModal from "../AddPhoneClienteModal";
import AddEndClienteModal from "../AddEndClienteModal";
import ItemEndereco from "../ItemEndereco";
import ItemPhone from "../ItemPhone";
import WebCamModal from "../WebCamModal";
import ModalVerifClienteExists from "../ModalVerifClienteExits";

import { Buttons, Container, Content, FormView, Header, ImgInput, TabCliente, TabEndereços, TabTelefones, TabsView } from "./styles";

type PhoneData = {
	emp_cod: string;
	id: string;
	numero: string;
	obs: string;
};
type EnderecoData = {
	id: string;
	cep: string;
	uf: string;
	cid: string;
	cidcod: string;
	bai: string;
	endereco: string;
	num: string;
	comp: string;
	ponto_ref: string;
	emp_cod: string;
};
type ClienteData = {
	id_cliente?: string;
	avatar_url: string;
	pessoa: string;
	id: string;
	nome: string;
	doc: string;
	rg: string;
	email: string;
	nasc: string;
	comissao: 2; // porcentagem
	sexo: string;
	emp_cod: string;
	enderecos: EnderecoData[],
	telefones: PhoneData[]
};
type ClassificacaoData = {
	value: string;
	label: string;
};

interface ModalParams {
	onClose: any;
	isVisible: boolean;
	id_cliente: string;
	fetchClientes: () => void;
	setClientesLoading: (loading: boolean) => void;
};

const ModalAddEditCliente: React.FC<ModalParams> = ({
	onClose = () => {},
	isVisible,
	id_cliente,
	fetchClientes,
	setClientesLoading
}) => {
	const formRefCliente = useRef<FormHandles>(null);

	const { user, company, token } = useAuth();
	const toast = useToast();

	const [loading, setLoading] = useState(true);

	const [pessoa, setPessoa] = useState('F');
	const [sexo, setSexo] = useState('M');
	const [classificacoes, setClassificacoes] = useState<ClassificacaoData[]>([]);
	const [fotoUrl, setFotoUrl] = useState<any>();
	const [img, setImg] = useState<any>(null);
	const [ isOpenCamModal, setIsOpenCamModal] = useState(false);
	const [cliente, setCliente] = useState<ClienteData>({} as ClienteData);
	const [isVerifClienteExistsModal, setIsVerifClienteExistsModal] = useState(false);
	const [verifDataModal, setVerifDataModal] = useState<any>({} as any);

	const [enderecos, setEnderecos] = useState<EnderecoData[]>([]);
	const [isNewEndClienteModal, setIsNewEndClienteModal] = useState(false);
	const [endModal, setEndModal] = useState<EnderecoData>({} as EnderecoData);

	const [phones, setPhones] = useState<PhoneData[]>([]);
	const [isNewPhoneClienteModal, setIsNewPhoneClienteModal] = useState(false);
	const [phoneModal, setPhoneModal] = useState<PhoneData>({} as PhoneData);

	const [openAlert, setOpenAlert] = useState(false);
	const [textAlert, setTextAlert] = useState({ header: '', body: '', is_toast: false });

	const [visible, setVisible] = useState(isVisible);
	const [tabIndex, setTabIndex] = useState(0);

	function handleCancel(is_toast: boolean) {
		if (!is_toast) {
			const r = window.confirm(
				'Você não salvou suas alterações!\nDeseja sair sem salvar?',
			);

			if (r) {
				setVisible(false);
				onClose(false);
			} else { return; };
		};

		toast({
			title: 'Cliente.',
			description: 'Cadastro de Cliente Cancelada!',
			status: 'warning',
			duration: 2000,
			position: 'top',
			isClosable: true,
			containerStyle: {
				marginTop: '5'
			}
		});

		setVisible(false);
		onClose(false);
	};

	async function handleClassificacoes() {
		await api.get('https://servicodados.ibge.gov.br/api/v2/cnae/divisoes')
			.then(response => {
				const auxClass = response.data.map((classi: any) => {
					return {
						value: classi.id,
						label: classi.descricao,
					}
				});

				// auxClass.unshift({ value: 0, label: '' });
				setClassificacoes(auxClass);
			}).finally(() => {
				formRefCliente.current?.setFieldValue('classif', '01');
			});
	};

	useEffect(() => {
		if (id_cliente) {
			let auxCliente = {} as ClienteData;

			api.post('/portal/cliente/one', { id_cliente })
				.then(async (response) => {
					setCliente(response.data);

					await handleClassificacoes();
					auxCliente = response.data;
				})
				.finally(() => {
					setLoading(false);

					setTimeout(() => {
						setPessoa(auxCliente.pessoa || 'F');
						setSexo(auxCliente.sexo || 'M');
						setEnderecos(auxCliente.enderecos);
						setPhones(auxCliente.telefones);
						formRefCliente.current?.setData(auxCliente);
					}, 200);
				});
		} else {
			setLoading(false);
		}
	}, []);

	function handleMaskCpf(value: string) {
		let res = value;
		res = res.replace(/\D+/g, '');
		res = res.replace(/(\d{3})(\d)/, "$1.$2");
		res = res.replace(/(\d{3})(\d)/, "$1.$2");
		res = res.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
		formRefCliente.current?.setFieldValue('doc', res);
	};

	function handleMaskCnpj(value: string) {
		let res = value;
		res = res.replace(/\D+/g, '');
		res = res.replace(/^(\d{2})(\d)/, "$1.$2")
		res = res.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
		res = res.replace(/\.(\d{3})(\d)/, ".$1/$2")
		res = res.replace(/(\d{4})(\d)/, "$1-$2")
		formRefCliente.current?.setFieldValue('doc', res);
	};

	async function handleSearchCnpj(cnpj: string) {
		const auxCnpj = cnpj.replace(/\D/g, '');

		if (auxCnpj.length === 0) {
			return;
		} else if (auxCnpj.length < 14) {
			toast({
				title: 'Cnpj.',
				description: 'Cnpj digita é inválido!',
				status: 'error',
				duration: 5000,
				position: 'top-right',
				isClosable: true,
				containerStyle: {
					marginTop: '20'
				}
			});
			return;
		};

		// delete api.defaults.headers.authorization;
		// delete api.defaults.headers.company;
    delete api.defaults.headers.common['Authorization'];
    delete api.defaults.headers.common['company'];

		await api.get(`https://brasilapi.com.br/api/cnpj/v1/${auxCnpj}`)
			.then(async (response) => {

				const {
					nome_fantasia,
					razao_social,
					data_inicio_atividade,
					cnae_fiscal,
					cep,
					numero,
					complemento,
					ddd_telefone_1,
					ddd_telefone_2,
					email,
				} = response.data;

				let auxPhones = [] as PhoneData[];
				let auxEnderecos = [] as EnderecoData[];

				if (razao_social === formRefCliente.current?.getFieldValue('nome')) {
					auxPhones = phones;
					auxEnderecos = enderecos;
				};

				formRefCliente.current?.setFieldValue('nome', razao_social);
				formRefCliente.current?.setFieldValue('nome_fantasia', nome_fantasia);
				formRefCliente.current?.setFieldValue('inicio_atividades', data_inicio_atividade);
				const indexClassif = classificacoes.findIndex(classi => classi.value === String(cnae_fiscal).substring(0, 2));
				formRefCliente.current?.setFieldValue('classif', classificacoes[indexClassif]);
				formRefCliente.current?.setFieldValue('email', email);
				formRefCliente.current?.getFieldRef('insc_estadual').focus();

				const indexEnd = enderecos.findIndex(end => end.cep === cep);
				if (indexEnd === -1) {
					const auxEndereco = await handleCep(cep);
					auxEndereco.num = numero;
					auxEndereco.comp = complemento;
					setEnderecos([...auxEnderecos, auxEndereco]);
				};

				const indexPhone1 = auxPhones.findIndex(phone => phone.numero === handleMaskPhone(ddd_telefone_1));
				const indexPhone2 = auxPhones.findIndex(phone => phone.numero === handleMaskPhone(ddd_telefone_2));

				if (indexPhone1 === -1 && ddd_telefone_1 !== '') {
					const auxPhone1 = { id: uuid(), emp_cod: company.id, numero: handleMaskPhone(ddd_telefone_1), obs: '' };
					if (indexPhone2 === -1 && ddd_telefone_2 !== '') {
						const auxPhone2 = { id: uuid(), emp_cod: company.id, numero: handleMaskPhone(ddd_telefone_2), obs: '' };
						setPhones([...auxPhones, auxPhone1, auxPhone2]);
					} else {
						setPhones([...auxPhones, auxPhone1]);
					};
				} else {
					if (indexPhone2 === -1 && ddd_telefone_2 !== '') {
						const auxPhone2 = { id: uuid(), emp_cod: company.id, numero: handleMaskPhone(ddd_telefone_2), obs: '' };
						setPhones([...auxPhones, auxPhone2]);
					};
				};
			})
			.catch(err => {
				toast({
					title: 'CNPJ.',
					description: err.response.data.message,
					status: 'error',
					duration: 5000,
					position: 'top-right',
					isClosable: true,
					containerStyle: {
						marginTop: '20'
					}
				});
			})
			.finally(() => {
				// api.defaults.headers.authorization = `Bearer ${token}`;
				// api.defaults.headers.company = company.id;
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        api.defaults.headers.common['company'] = company.id;
			});
	};

	async function handleResizeFile(file: any) {
		return new Promise(resolve => {
			Resizer.imageFileResizer(
				file,
				1920,
				1080,
				'JPEG',
				80,
				0,
				uri => {
					resolve(uri);
				},
				'file',
			);
		});
	};

	async function handleImagemChange(event: ChangeEvent<HTMLInputElement>) {
		if (event.target.files && event.target.files.length > 0) {
			const file = event.target.files[0];

			const size = parseFloat((file.size / 1024 / 1024).toFixed(1));

			// Se for maior que 4 megabytes
			if (size > 4) {
				alert('Tamanho da imagem superior ao permitido!');
				return;
			}

			if (size > 1) {
				const aux: any = await handleResizeFile(file);

				setImg(aux);
				setFotoUrl(URL.createObjectURL(aux));
			} else {
				setImg(event.target.files[0]);
				setFotoUrl(URL.createObjectURL(event.target.files[0]));
			}
		}

		event.target.value = '';
	};

	async function handleRemoveImg() {
		setImg(null);
		setFotoUrl(null);
	};

	async function handleSubmitTabCliente(form: any) {
		try {
			formRefCliente.current?.setErrors({});

			let schema;

			switch (pessoa) {
				case 'J':
					schema = Yup.object().shape({
						doc: Yup.string().required('CNPJ é obrigatório'),
						nome: Yup.string().required('Nome obrigatório.'),
						nome_fantasia: Yup.string(),
						inicio_atividades: Yup.string(),
						classif: Yup.string(),
						insc_estadual: Yup.string(),
						rg: Yup.string(),
						nasc: Yup.string(),
						email: Yup.string().email('E-mail inválido.'),
					});
					break;
				default:
					schema = Yup.object().shape({
						doc: Yup.string(),
						nome: Yup.string().required('Nome obrigatório.'),
						email: Yup.string().email('E-mail inválido.'),
						rg: Yup.string(),
						nasc: Yup.string(),
					});
			};

			await schema.validate(form, { abortEarly: false });

			if (pessoa === 'F') {
				form.sexo = sexo;
			};

			const auxCliente = {
				...cliente,
				...form,
				emp_cod: cliente.emp_cod ? cliente.emp_cod : company.id,
				sexo,
				pessoa,
			};

			setCliente(auxCliente);

			if (!auxCliente.id) {
				await api.post('/portal/cliente/exists', { cliente: auxCliente })
					.then(response => {
						const verif = response.data;
						verif.clie_json = JSON.parse(verif.clie_json);

						if (verif.bloquear === 'S' || verif.bloquear === 'A') {
							setVerifDataModal(verif);
							setIsVerifClienteExistsModal(true);
						} else {
							setTabIndex(1);
						}
					});
			} else {
				setTabIndex(1);
			}
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRefCliente.current?.setErrors(errors);
			}
		}
	};

	async function handleCep(value: string): Promise<EnderecoData> {
		let cep = value;
		let endereco = {} as EnderecoData;
		// Verifica se campo cep possui valor informado
		if (cep !== '' || cep !== undefined || cep !== null) {
			cep = cep.replace(/\D/g, '');
			// Expressão regular para validar o CEP.
			const validacep = /^[0-9]{8}$/;
			// Valida o formato do CEP.
			if (validacep.test(cep)) {
				// delete api.defaults.headers.authorization;
				// delete api.defaults.headers.company;
        delete api.defaults.headers.common['Authorization'];
        delete api.defaults.headers.common['company'];

				await api
					.get(`https://viacep.com.br/ws/${cep}/json`, { headers: { "Access-Control-Allow-Origin": "*" } })
					.then(response => {

						const { localidade, bairro, logradouro, uf, ibge } = response.data;

						const auxEnd: EnderecoData = {
							id: uuid(),
							cep: value,
							uf,
							cid: localidade,
							cidcod: ibge,
							bai: bairro,
							endereco: logradouro,
							num: '',
							comp: '',
							ponto_ref: '',
							emp_cod: company.id,
						};

						endereco = auxEnd;
					})
					.catch(err => {
						/* addToast({
							type: 'error',
							title: 'Erro no CEP',
							description: `ERROR - ${err}`,
						}); */
					})
					.finally(() => {
						// api.defaults.headers.authorization = `Bearer ${token}`;
						// api.defaults.headers.company = company.id;
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            api.defaults.headers.common['company'] = company.id;
					});
			} else {
				/* addToast({
					type: 'error',
					title: 'Erro no CEP',
					description: 'CEP digitado é inválido.',
				}); */
			};
		};

		return endereco;
	};

	async function handleSubmitEnderecos() {
		setTabIndex(2);
	};

	function handleMaskPhone(event: string) {
		let res = event;
		res = res.replace(/\D/g, '');
		res = res.replace(/^(\d{2})(\d)/g, '($1) $2');
		res = res.replace(/(\d)(\d{4})$/, '$1-$2');
		return res;
	};

	async function handleSubmit() {
		try {
			const data = new FormData();

			const auxCliente: ClienteData = {
				...cliente,
				id: cliente.id || uuid(),
				telefones: phones,
				enderecos: enderecos
			};

			if (img) {
				data.append('image', img);
			};

			data.append('cliente', JSON.stringify(auxCliente));

			await api.post('/portal/cliente/store', data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
				.then(response => {
					const { confirmado, mensagem } = response.data;

					if (confirmado === 'S') {
						toast({
							title: 'CLIENTE.',
							description: mensagem,
							status: 'success',
							duration: 3000,
							position: 'top',
							isClosable: true,
							containerStyle: {
								marginTop: '5'
							}
						});

						// formRefCliente.current?.reset();
						onClose();
						fetchClientes();
						setClientesLoading(true);
					} else {
						toast({
							title: 'CLIENTE.',
							description: mensagem,
							status: 'error',
							duration: 5000,
							position: 'top',
							isClosable: true,
							containerStyle: {
								marginTop: '5'
							}
						});
					};
				});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRefCliente.current?.setErrors(errors);
			}
		}
	};

	return (
		<Container id="ModalProduto">
			<Content className={`${visible ? 'active' : ''}`}>
				<Header>
					<h1>Cadastro de Cliente</h1>
				</Header>

				<TabsView>
					<Tabs className="tabs" index={tabIndex}>
						<TabList className="tab-list">
							<Tab className="tab" onClick={() => setTabIndex(0)}>
								Cliente
							</Tab>

							<Tab className="tab" onClick={() => setTabIndex(1)}>
								Endereços
							</Tab>

							<Tab className="tab" onClick={() => setTabIndex(2)}>
								Telefones
							</Tab>
						</TabList>

						<TabPanels className="tab-panels">
							<TabCliente className="tab-panel">
								{loading
								? <LoadingTabCliente />
								: (
										<div className="tab-content">
											<Header>
												<h2>Adicione os dados do cliente aqui.</h2>
											</Header>

											<FormView ref={formRefCliente} onSubmit={handleSubmitTabCliente}>
												{/* AVATAR - PESSOA / DOCUMENTO */}
												<Flex flexDir={["column", "row"]} align="center">
													<Flex px={8} pr={12} py={4} align="center" justify="center">
														<ImgInput>
															<Image
																src={
																	fotoUrl
																		? fotoUrl
																			: cliente.avatar_url
																				? cliente.avatar_url
																				: 'https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png'
																}
																alt="Imagem Perfil"
																boxSize="120px"
																borderRadius="full"
																objectFit="cover"
															/>

															<label className="select-camera"
																onClick={() => setIsOpenCamModal(true)}
															>
																<FiCamera size={2} />
															</label>

															<label className="select-picture" htmlFor="imagem">
																<FiImage size={2} />

																<input
																	type="file"
																	id="imagem"
																	name="imagem"
																	onChange={handleImagemChange}
																/>
															</label>

															{
																// img || product?.url_imagem ? (
																fotoUrl ? (
																	<label
																		className="remove-picture"
																		onClick={handleRemoveImg}
																	>
																		<FiX />
																	</label>
																) : null
															}
														</ImgInput>
													</Flex>

													{/* PESSOA / DOCUMENTO */}
													<Flex flexDir="column" width="100%">
														{/* PESSOA - FÍSICA / JURÍDICA */}
														<Flex flexDir="column" pt="2">
															<Flex align="center">
																<Icon as={pessoa === 'F' ? MdFace : RiStore2Line} fontSize="18" mr="2" />
																<Text fontSize="18">Pessoa: </Text>
															</Flex>
															<RadioGroup
																onChange={(e: any) => {
																	setPessoa(e);
																	formRefCliente.current?.reset();
																}}
																value={pessoa}
																borderWidth={1}
																borderColor="#b0bec5"
																borderRadius={6}
																pl="4"
																py="2.5"
															>
																<Stack direction='row' spacing="4">
																	<Radio value='F'>Física</Radio>
																	<Radio value='J'>Jurídica</Radio>
																</Stack>
															</RadioGroup>
														</Flex>

														{/* DOCUMENTO */}
														<Stack w="100%" spacing={[0, 4]} direction="row">
															{/* DOCUMENTO */}
															<div className="input">
																<p>{pessoa === 'F' ? 'Cpf' : 'Cnpj'}
																	{pessoa === 'J' && (
																		<span>&nbsp;(obrigatório *)</span>
																	)}
																</p>
																<Input
																	name="doc"
																	type="text"
																	placeholder="Documento"
																	onChange={(e: any) => pessoa === 'F'
																		? handleMaskCpf(e.target.value)
																		: handleMaskCnpj(e.target.value)
																	}
																	handleOnBlur={(e: any) => pessoa === 'J' && handleSearchCnpj(e.target.value)}
																	maxLength={pessoa === 'F' ? 14 : 18}
																	containerStyle={{ padding: '6px 0 6px 10px' }}
																/>
															</div>
														</Stack>
													</Flex>
												</Flex>

												{/* NOME */}
												<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
													{/* NOME */}
													<div className="input">
														<p>Nome <span>(obrigatório *)</span></p>

														<Input
															name="nome"
															type="text"
															placeholder="Nome"
															containerStyle={{ padding: '6px 0 6px 10px' }}
														/>
													</div>
												</Stack>

												{pessoa === 'J' && (
													<>
														{/* NOME FANTASIA - INÍCIO ATIVIDADE */}
														<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
															{/* NOME FANTASIA */}
															<div className="input">
																<p>Nome Fantasia</p>
																<Input
																	name="nome_fantasia"
																	type="text"
																	placeholder="Nome Fantasia"
																	containerStyle={{ padding: '6px 0 6px 10px' }}
																/>
															</div>

															{/* INÍCIO ATIVIDADE */}
															<div className="input">
																<p>Início das atividades</p>
																<InputDate
																	name="inicio_atividades"
																	placeholder="Início das atividades"
																	containerStyle={{ padding: '6px 10px' }}
																/>
															</div>
														</Stack>

														{/* CLASSIFICAÇÃO */}
														<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
															{/* CLASSIFICAÇÃO */}
															<div className="input">
																<p>Classificação</p>
																<SelectInput
																	name="classif"
																	placeholder="Classificação"
																	options={classificacoes}
																/>
															</div>
														</Stack>

														{/* INSCRIÇÃO ESTADUAL */}
														<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
															{/* INSCRIÇÃO ESTADUAL */}
															<div className="input">
																<p>Inscrição estadual</p>
																<Input
																	name="insc_estadual"
																	type="text"
																	placeholder="Inscrição estadual"
																	containerStyle={{ padding: '6px 0 6px 10px' }}
																/>
															</div>
														</Stack>
													</>
												)}

												{/* EMAIL */}
												<Stack w="100%" spacing={[0, 4]} direction={['column', 'column', 'row']}>
													{/* EMAIL */}
													<div className="input">
														<p>E-mail</p>
														<Input
															name="email"
															type="email"
															placeholder="E-mail"
															containerStyle={{ padding: '6px 0 6px 10px' }}
														/>
													</div>
												</Stack>

												{pessoa === 'F' && (
													<>
														{/* RG - DATA NASCIMENTO */}
														<Stack w="100%" spacing={4} direction="row">
															{/* RG */}
															<div className="input">
																<p>RG</p>
																<Input
																	name="rg"
																	type="text"
																	placeholder="RG"
																	containerStyle={{ padding: '6px 0 6px 10px' }}
																/>
															</div>

															{/* DATA NASCIMENTO */}
															<div className="input">
																<p>Data de Nascimento</p>
																<InputDate
																	name="nasc"
																	placeholder="Data de Nascimento"
																	containerStyle={{ padding: '6px 10px' }}
																/>
															</div>
														</Stack>

														{/* SEXO */}
														<Stack w="100%" mt={2} spacing={4} direction="row">
															<Flex flexDir="column" w="100%">
																<Flex align="center">
																	<Icon as={sexo === 'F' ? RiWomenLine : RiMenLine}
																		fontSize="18"
																		mr="2"
																	/>
																	<Text fontSize="18">Sexo: </Text>
																</Flex>
																<RadioGroup
																	onChange={setSexo}
																	value={sexo}
																	borderWidth={1}
																	borderColor="#b0bec5"
																	borderRadius={6}
																	pl="4"
																	py="2.5"
																>
																	<Stack direction='row' spacing="4">
																		<Radio value='M'>Masculino</Radio>
																		<Radio value='F'>Feminino</Radio>
																	</Stack>
																</RadioGroup>
															</Flex>
														</Stack>
													</>
												)}

												<Buttons>
													<Flex flexDir="column" pl={4} py={0}>
														<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
														<Text pl={2} fontSize={[10, 15]} fontWeight={500}>{user.nome}</Text>
													</Flex>

													<Flex className="buttons">
														<button
															type="button"
															className="button-cancel"
															onClick={() => {
																setTextAlert({
																	header: `Cancelar ${id_cliente ? 'Alteração' : 'Criação'} do Cliente!`,
																	body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
																	is_toast: true,
																});
																setOpenAlert(true);
															}}
														>
															Cancelar
														</button>

														<button type="submit" className="button-save">
															Próximo
														</button>
													</Flex>
												</Buttons>
											</FormView>
										</div>
								)}
							</TabCliente>

							<TabEndereços className="tab-panel">
								<div className="tab-content">
									<Header>
										<Flex flexDir={["column", "row"]} justify="space-between" align="center">
											<h2>Adicione endereços para o cliente aqui.</h2>

											<Flex width={["100%", "auto"]} justify="flex-end" className="buttons" p={0}>
												<button
													className="button-save"
													style={{ paddingTop: "5px", paddingBottom: "5px", margin: "0" }}
													onClick={() => {
														setEndModal({} as EnderecoData);
														setIsNewEndClienteModal(true);
													}}
												>
													+ Novo
												</button>
											</Flex>
										</Flex>
									</Header>

									<Flex flexDir="column" mt={2} p={2}>
										{enderecos.length > 0 ?
											<>
												<Flex align="center" pb={2} borderBottomWidth={1} borderBottomColor="gray.100">
													<Icon as={RiMap2Line} fontSize={21} mr={2} />
													<Text fontSize={18} mr="4">Endereços</Text>
												</Flex>

												{enderecos.map((endereco) => {
													return (
														<Flex key={endereco.id} py="2" flexDir="column">
															<Stack spacing="2">
																<ItemEndereco
																	endereco={endereco}
																	setEndModal={setEndModal}
																	setIsNewEndClienteModal={setIsNewEndClienteModal}
																	enderecos={enderecos}
																	setEnderecos={setEnderecos}
																/>
															</Stack>
														</Flex>
													)
												})}
											</>
											: (
												<Flex w="100%" justify="center" py={4}>
													<Text color="gray.400" fontWeight="bold">Nenhum endereço</Text>
												</Flex>
											)
										}
									</Flex>

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[10, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${id_cliente ? 'Alteração' : 'Criação'} do Cliente!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>

											<button className="button-save" onClick={handleSubmitEnderecos}>
												Próximo
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabEndereços>

							<TabTelefones className="tab-panel">
								<div className="tab-content">
									<Header>
										<Flex flexDir={["column", "row"]} justify="space-between" align="center">
											<h2>Adicione telefones para o cliente aqui.</h2>

											<Flex width={["100%", "auto"]} justify="flex-end" className="buttons" p={0}>
												<button
													className="button-save"
													style={{ paddingTop: "5px", paddingBottom: "5px", margin: "0" }}
													onClick={() => {
														setPhoneModal({} as PhoneData);
														setIsNewPhoneClienteModal(true);
													}}
												>
													+ Novo
												</button>
											</Flex>
									</Flex>
									</Header>

									<Flex flexDir="column" mt={2} p={2}>
										{phones.length > 0 ?
											<>
												<Flex align="center" pb={2} borderBottomWidth={1} borderBottomColor="gray.100">
													<Icon as={MdOutlineAddIcCall} fontSize={21} mr={2} />
													<Text fontSize={18} mr="4">Telefones</Text>
												</Flex>

												{phones.map((phone) => {
													return (
														<Flex py="2" flexDir="column" key={phone.id}>
															<Stack spacing="2">
																<ItemPhone
																	phone={phone}
																	setPhoneModal={setPhoneModal}
																	setIsNewPhoneClienteModal={setIsNewPhoneClienteModal}
																	phones={phones}
																	setPhones={setPhones}
																/>
															</Stack>
														</Flex>
													)
												})}
											</>
											: (
												<Flex w="100%" justify="center" py={4}>
													<Text color="gray.400" fontWeight="bold">Nenhum endereço</Text>
												</Flex>
											)
										}
									</Flex>

									<Buttons>
										<Flex flexDir="column" pl={4} py={0}>
											<Text fontSize={[10, 14]} fontWeight={400}>Usuário:</Text>
											<Text pl={2} fontSize={[10, 15]} fontWeight={500}>{user.nome}</Text>
										</Flex>

										<Flex className="buttons">
											<button
												type="button"
												className="button-cancel"
												onClick={() => {
													setTextAlert({
														header: `Cancelar ${id_cliente ? 'Alteração' : 'Criação'} do Cliente!`,
														body: 'Você não salvou suas alterações!' + "\n" + 'Deseja sair sem salvar?',
														is_toast: true,
													});
													setOpenAlert(true);
												}}
											>
												Cancelar
											</button>

											<button className="button-save" onClick={handleSubmit}>
												SALVAR
											</button>
										</Flex>
									</Buttons>
								</div>
							</TabTelefones>
						</TabPanels>
					</Tabs>
				</TabsView>
			</Content>

			{isVerifClienteExistsModal && (
				<ModalVerifClienteExists
					isVisible={isVerifClienteExistsModal}
					onClose={setIsVerifClienteExistsModal}
					verifData={verifDataModal}
					setCliente={setCliente}
					setEnderecos={setEnderecos}
					setPhones={setPhones}
					handleCancel={handleCancel}
					formRefCliente={formRefCliente}
					setTabIndex={setTabIndex}
					cliente={cliente}
				/>
			)}

			{isNewPhoneClienteModal && (
				<AddPhoneClienteModal
					isOpen={isNewPhoneClienteModal}
					onRequestClose={setIsNewPhoneClienteModal}
					setPhones={setPhones}
					phones={phones}
					phoneModal={phoneModal}
					setPhoneModal={setPhoneModal}
				/>
			)}

			{isNewEndClienteModal && (
				<AddEndClienteModal
					isVisible={isNewEndClienteModal}
					onClose={setIsNewEndClienteModal}
					setEnderecos={setEnderecos}
					enderecos={enderecos}
					endModal={endModal}
					setEndModal={setEndModal}
				/>
			)}

			{isOpenCamModal && (
				<WebCamModal
					isOpen={isOpenCamModal}
					onRequestClose={setIsOpenCamModal}
					setImg={setImg}
					setFotoUrl={setFotoUrl}
				/>
			)}

			{openAlert && (
				<Alert
					isOpen={openAlert}
					onRequestClose={setOpenAlert}
					textAlert={textAlert}
					execFunction={handleCancel}
				/>
			)}
		</Container>
	)
};

export default ModalAddEditCliente;
